import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { routerCancelAction } from '@ngrx/router-store';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class MsinInterceptorService implements HttpInterceptor {
    constructor(
				private router: Router
		) {
    }

	iRunOnce: number = 0;
	private isEnabled: boolean = false;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            const idToken = localStorage.getItem("id_token");
    /*let newUrl = "";
    if (idToken)
    {
      const cloned = req.clone({
        url:newUrl
      });
    }
    else
    {
      next.handle(req);
    }*/

        if (this.isEnabled) { 
            if (this.router.url )
			{ 
				if ((this.router.url != '/children/search') && (this.router.url != '/') && (this.router.url != '/login')) {
					try {

						this.fnShowDiagnostic(idToken);
				
						console.log("router url not dashboard")
						
						console.log("loading dashboard via step a")
						this.router.navigateByUrl('/children/search');							


					} catch (Err) {
						this.fnShowDiagnostic(idToken);
						console.log('error capturing router url');
						console.log(Err);
					}
				}
	
	
            }
			else
			{
				this.fnShowDiagnostic(idToken);
		
				console.log("loading dashboard via step b")
				
				this.router.navigateByUrl('/children/search');							
			}

        }
        return next.handle(req);
    }

	enable() {
		this.isEnabled = true;	
	}

	disable(){
		this.isEnabled = false;
	}

	fnShowDiagnostic(idToken: any) {
		if (this.isEnabled)
		{
			console.log("now intercepting: ")
			console.log(idToken)
			console.log(this.router.url)		

		}
	}
}
